import React from 'react';
import Flexbox from 'flexbox-react';
import { css } from 'emotion';
import ProcessUtils from 'utils/ProcessUtils';
import TransformationParameter from 'components/core/fields/transformation_parameters/TransformationParameter';
import MessageBox from 'components/core/MessageBox';
import DatastreamDefaultsTable from 'components/core/fields/transformation_parameters/DatastreamDefaultsTable.js';
import OverrideTable from 'components/core/fields/transformation_parameters/OverrideTable';
import InfoIcon from 'components/core/InfoIcon';
import InfoMessages from 'components/core/help/InfoMessages';

export default class QCBadParameter extends TransformationParameter {
    static defaultProps = {
        parameterNames: ['qc_bad'],
        isOverridable: true,
        isDatastreamDefaultVisibileInitially: true,
        isOverrideVisibleInitially: true,
        infoBoxText: '',
    };

    renderMessageBox = () => {
        const preListText = 'We detected integer QC for the following variables:';

        return (
            <MessageBox>
                <Flexbox flexDirection={'column'}>
                    {this.getMessageBoxVariableList(preListText)}
                    <p>For non-bitpacked QC variables, all values will be considered indeterminate if they have not been explicitly set to bad in the PCM.</p>
                </Flexbox>
            </MessageBox>
        );
    };

    renderNoFoundVariablesInfo = () => {
        const variables = ProcessUtils.getVariablesWithRelevantExploredData(this.props.process, this.props.parameterNames[0], this.props.exploredDatastreams);
        if (Object.keys(variables).length === 0) {
            return (
                <InfoIcon message={InfoMessages.noQCBad}/>
            )
        }

        return null;
    };

    renderDatastreamDefaultQuestionText = () => {
        return (
            <Flexbox flexDirection={'row'}>
                {this.renderNoFoundVariablesInfo()}
                Do you want to interpret some integer QC values as bad by input datastream?
            </Flexbox>
        );
    };

    renderOverrideQuestionText = () => {
        return (
            <Flexbox flexDirection={'row'}>
                {this.renderNoFoundVariablesInfo()}
                Do you want to interpret some integer QC values as bad by variable?
            </Flexbox>
        );
    };

    renderDatastreamDefaultTable = () => {
        return (
            <QCBadDatastreamDefaultsTable
                process={this.props.process}
                processErrors={this.props.processErrors}
                parameterNames={this.props.parameterNames}
                displayInputDatastream={this.props.displayInputDatastream}
                hasWritePermissions={this.props.hasWritePermissions}
                className={css`width:100%;`}
            />
        );
    };

    renderOverrideTable = () => {
        return (
            <QCBadOverrideTable
                process={this.props.process}
                processErrors={this.props.processErrors}
                parameterNames={this.props.parameterNames}
                hasWritePermissions={this.props.hasWritePermissions}
                displayInputDatastream
            />
        );
    }
}

class QCBadDatastreamDefaultsTable extends DatastreamDefaultsTable {

    getAdditionalColumns() {
        return ([
            {
                property: 'data',
                header: {
                    label: 'Bad QC values',
                },
                cell: {
                    formatters: [
                        data => { return this.renderBadQC(data); }
                    ]
                }
            },
            {
                property: 'data',
                header: {
                    label: 'Indeterminate QC values',
                },
                cell: {
                    formatters: [
                        data => { return this.renderIndQC(data); }
                    ]
                }
            },
            {
                property: 'data',
                header: {
                    label: 'List of indeterminate QC integer values that should be interpreted as bad',
                },
                cell: {
                    formatters: [
                        data => { return this.renderBadQCList(data); }
                    ]
                }
            }
        ]);
    }
}

class QCBadOverrideTable extends OverrideTable {

    getAdditionalColumns() {
        return ([
            {
                property: 'data',
                header: {
                    label: 'Bad QC values',
                },
                cell: {
                    formatters: [
                        data => { return this.renderBadQC(data); }
                    ]
                }
            },
            {
                property: 'data',
                header: {
                    label: 'Indeterminate QC values',
                },
                cell: {
                    formatters: [
                        data => { return this.renderIndQC(data); }
                    ]
                }
            },
            {
                property: 'data',
                header: {
                    label: 'List of indeterminate QC integer values that should be interpreted as bad',
                },
                cell: {
                    formatters: [
                        data => { return this.renderBadQCList(data); }
                    ]
                }
            }
        ]);
    }
}



// WEBPACK FOOTER //
// ./src/components/core/fields/transformation_parameters/QCBadParameter.js